<template>
  <div class="registerPopUp">
    <img class="registerBanner" :src="`${mediaUrl}/menu/PopupRegister_${currentLanguage}.jpg`" width="100%" height="auto" />
    <v-row no-gutters class="register_panel-af" :class="$vuetify.breakpoint.mdAndDown ? '' : ''">
      <v-row no-gutters class="registerGuideSection" v-if="showRegisterGuide">
        <v-col class="pa-0" cols="11">
          <div class="d-flex align-center">
            <img src="/static/image/profile/guideIcons.png" width="25" height="25" :contain="true" />
            <label class="px-3">
              {{ $t(`label.registerGuide`) }} {{ $t(`label.clickThis`) }}
              <a href="https://ng88.wistia.com/s/nwb726b642zl2fs" target="_blank" class="linkText">{{ $t(`label.link`) }}</a>
              {{ $t(`label.watchVideo`) }}
            </label>
          </div>
        </v-col>
        <v-col cols="1" class="pa-0 d-flex justify-center align-center">
          <v-img @click="closeShowRegisterGuide()" src="/static/image/profile/closeIcon.png" width="15" height="15" :contain="true"></v-img>
        </v-col>
      </v-row>
      <v-row no-gutters class="register-wrapper-af" :class="$vuetify.breakpoint.mdAndDown ? '' : 'px-5 '">
        <v-col class="no-gutters">
          <!--          <v-row cols="12" no-gutters class="sign-up-title" v-if="$vuetify.breakpoint.mdAndUp">-->
          <!--            <label class="h6">{{ $t(`label.joininregister`) }}</label>-->
          <!--          </v-row>-->
          <v-window v-model="step" :touchless="true">
            <v-window-item :value="1" :key="1">
              <v-form ref="registerForm1">
                <v-card-text class="ma-0 pa-0">
                  <app-form-field
                    class="registerformfield"
                    :enabledLabel="true"
                    v-model.trim="registerObj.memberCode"
                    :label="$t(`field.username`)"
                    :placeholder="$t(`fieldHint.username`)"
                    key="username"
                    :errorMsg="userNameErrorMsg"
                    :blur="checkUsername"
                    :rules="validator.usernameRules(registerObj.password)"
                  ></app-form-field>
                  <app-form-field
                    class="registerformfield"
                    ref="regPassword"
                    :enabledLabel="true"
                    v-model.trim="registerObj.password"
                    :label="$t(`field.password`)"
                    :placeholder="$t(`fieldHint.password2`)"
                    :rules="validator.changePasswordRules(registerObj.memberCode)"
                    :allowShowPassword="false"
                    type="password"
                    prependInnerIcon="mdi-lock-outline"
                  ></app-form-field>
                  <app-form-field
                    class="registerformfield"
                    :enabledLabel="true"
                    v-model.trim="confirmNewPassword"
                    :label="$t(`field.confirmPassword`)"
                    :placeholder="$t(`fieldHint.confirmpassword2`)"
                    :rules="validator.confirmPasswordRules(registerObj.password, confirmNewPassword)"
                    :allowShowPassword="false"
                    type="password"
                    prependInnerIcon="mdi-lock-outline"
                  ></app-form-field>
                </v-card-text>
                <!--                <v-row cols="12" no-gutters class="d-flex justify-center align-center">-->
                <!--                  <v-btn class="text-capitalize circle-button"-->
                <!--                         style="color: #fff; background: transparent linear-gradient(180deg, #FFAB2D 0%, #FF7700 100%); width: 100%;"-->
                <!--                         @click="this.nextPage">-->
                <!--                    {{ $t(`button.continue`) }}-->
                <!--&lt;!&ndash;                    <v-icon>mdi-arrow-right</v-icon>&ndash;&gt;-->
                <!--                  </v-btn>-->
                <!--                </v-row>-->
                <!--                <v-row cols="12" no-gutters class="d-flex justify-center align-center">-->
                <!--                  <p class="mt-5 text-center body-1" style="color: #9F9F9F;">-->
                <!--                    {{ $t(`message.alreadyHaveAccount`) }}-->
                <!--                    <v-btn text height="auto" @click="this.openLogin" class="pa-0"-->
                <!--                           style="color: #0047FF; text-decoration: underline;">{{ $t(`label.login`) }}</v-btn>-->
                <!--                  </p>-->
                <!--                </v-row>-->
              </v-form>

              <v-form ref="registerForm2">
                <v-row no-gutters>
                  <v-col cols="12">
                    <app-form-field
                      :enabledLabel="true"
                      v-model.trim="registerObj.currency"
                      :label="$t(`field.currency`)"
                      type="select"
                      :disabled="true"
                      height:30
                      :rules="validator.dropDownListRules()"
                      :items="currencyList"
                      class="registerformfield black--text"
                    ></app-form-field>
                  </v-col>
                </v-row>
                <v-card-text class="ma-0 pa-0">
                  <label class="input-field-label ma-0 pb-2 text-capitalize d-block">
                    {{ $t(`field.phoneNumber`) }}
                    <span class="red--text ml-1">*</span>
                  </label>
                  <v-row no-gutters>
                    <v-col cols="6">
                      <v-select
                        elevation="2"
                        v-model.trim="registerObj.dialCode"
                        class="registerformfield input-field mr-2 black--text"
                        item-text="text"
                        item-value="value"
                        :items="mobileNumberPrefixList"
                        dense
                        outlined
                        :readonly="true"
                      >
                        <template #prepend-inner>
                          <v-btn icon small>
                            <v-avatar size="25" class="language-button">
                              <img width="25" height="25" :src="`/static/image/country/${currentCurrency}.svg`" alt="nagad88 cricket exchange" />
                            </v-avatar>
                          </v-btn>
                        </template>
                      </v-select>
                    </v-col>

                    <v-col cols="6" ref="phonenumber">
                      <app-form-field
                        class="registerformfield 14fontsize"
                        :enabledLabel="false"
                        v-model.trim="registerObj.mobileNumber"
                        :rules="validator.mobileNumberRules(registerObj.language)"
                        :placeholder="$t(`fieldHint.phoneNumber2`)"
                        :isOptional="true"
                      ></app-form-field>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-form>
              <v-form ref="registerForm3">
                <v-card-text class="ma-0 pa-0">
                  <!--                  <v-row no-gutters>-->
                  <!--                    <v-col cols="12">-->
                  <!--                      <app-form-field-->
                  <!--                        class="registerformfield"-->
                  <!--                        :enabledLabel="true"-->
                  <!--                        v-model.trim="registerObj.email"-->
                  <!--                        :label="$t(`field.email`)"-->
                  <!--                        :isOptional="true"-->
                  <!--                        :placeholder="$t(`fieldHint.fillUpHere2`)"-->
                  <!--                        :rules="validator.emailRules()"-->
                  <!--                      ></app-form-field>-->
                  <!--                    </v-col>-->
                  <!--                  </v-row>-->
                  <!--                  <v-row no-gutters>-->
                  <!--                    <v-col cols="12">-->
                  <!--                      <app-form-field-->
                  <!--                        class="registerformfield"-->
                  <!--                          :enabledLabel="true"-->
                  <!--                          v-model.trim="registerObj.referralCode"-->
                  <!--                          :label="$t(`field.referralCode`)"-->
                  <!--                        readonly-->
                  <!--                          :rules="validator.referralCodeRules()"-->
                  <!--                          :readonly="isReferralCodeReadonly"-->
                  <!--                          :isOptional="true"-->
                  <!--                      ></app-form-field>-->
                  <!--                    </v-col>-->
                  <!--                  </v-row>-->
                  <v-row no-gutters>
                    <v-col cols="12">
                      <app-form-field
                        class="registerformfield specialgrey"
                        :enabledLabel="true"
                        :label="$t(`field.referralCode`)"
                        :placeholder="$t(`fieldHint.referralCode2`)"
                        readonly
                        :rules="validator.referralCodeRules()"
                        :isOptional="true"
                        v-model.trim="registerObj.referralCode"
                      ></app-form-field>
                    </v-col>
                  </v-row>

                  <!--                  <v-row no-gutters>-->
                  <!--                    <v-col cols="12">-->
                  <!--                      <v-checkbox class="mt-0 pt-0" :rules="validator.requiredRules()">-->
                  <!--                        <template v-slot:label>-->
                  <!--                          <p class="caption pt-0 mb-0">-->
                  <!--                            <label style="font-size: 14px !important;">{{ $t(`message.registerDisclaimer_1`) }}</label>-->
                  <!--                            <label class="secondary&#45;&#45;text font-weight-bold" style="cursor: pointer; font-size: 14px !important;" @click="openRegisterTncDialog">-->
                  <!--                              {{ $t(`message.registerDisclaimer_2`) }}-->
                  <!--                            </label>-->
                  <!--                          </p>-->
                  <!--                        </template>-->
                  <!--                      </v-checkbox>-->
                  <!--                    </v-col>-->
                  <!--                  </v-row>-->
                  <v-row no-gutters class="d-flex justify-center align-center">
                    <!--                    <v-btn class="circle-button text-capitalize" style="color: #fff; background: transparent linear-gradient(180deg, #0047FF 0%, #5A00B4 100%);"-->
                    <!--                           @click="this.previousPage">-->
                    <!--                      <v-icon>mdi-arrow-left</v-icon>-->
                    <!--                      {{ $t(`button.back`) }}-->
                    <!--                    </v-btn>-->
                    <v-btn width="100%" class="circle-button text-capitalize" style="color: #fff; background: transparent linear-gradient(180deg, #FFAB2D 0%, #FF7700 100%);" @click="this.register">
                      {{ $t(`button.joinNow`) }}
                      <!--                      <v-icon>mdi-check</v-icon>-->
                    </v-btn>
                  </v-row>
                </v-card-text>
              </v-form>
            </v-window-item>
            <!-- <v-window-item :value="2">
                      <div class="pa-4 text-center">
                          <v-img class="mb-4" contain height="128" src="https://cdn.vuetifyjs.com/images/logos/v.svg"></v-img>
                          <h3 class="text-h6 font-weight-light mb-2">
                              Welcome to Vuetify
                          </h3>
                          <span class="text-caption grey--text">Thanks for signing up!</span>
                      </div>
                  </v-window-item> -->
            <!-- <v-row no-gutters>
                      <v-col cols=12 class="mt-5">
                      <v-item-group v-model="step" class="text-center" mandatory>
                          <v-item v-for="n in regSteps" :key="`btn-${n}`" v-slot="{ active, toggle }">
                          <v-btn color="white" class="ma-2 resgiter-dialog-pagination"
                                  active-class="resgiter-dialog-pagination-active" x-small icon :input-value="active"
                                  @click="toggle" :disabled="true">
                              {{ n }}
                          </v-btn>
                          </v-item>
                          <v-item v-slot="{ active, toggle }">
                          <v-btn active-class="resgiter-dialog-pagination-active" icon :input-value="active" :disabled="true">
                              <v-icon>check_circle</v-icon>
                          </v-btn>
                          </v-item>
                      </v-item-group>
                      </v-col>
                  </v-row> -->
          </v-window>
          <!-- <p class="mt-5 text-center body-1">
                          {{ $t(`message.alreadyHaveAccount`) }}
                          <v-btn text height="auto" @click="openLogin" class="pa-0 text-uppercase font-weight-bold secondary--text">{{ $t(`label.signIn`) }}
                          </v-btn>
                      </p> -->
          <!-- <div v-if="step == 0">
                      <v-row no-gutters class="py-6">
                          <v-col cols="12">
                          <v-divider class="dialog-divider"></v-divider>
                          </v-col>
                      </v-row>
                      <v-row no-gutters>
                          <v-col cols=12>
                          <label class="input-field-label ma-0 pb-1 d-block title_color2--text">
                              {{ $t(`message.alreadyHaveAccount`) }}</label>
                          </v-col>
                      </v-row>
                      <v-row no-gutters>
                          <v-col cols="12">
                          <v-btn height="auto" @click="openLogin" color="black" depressed
                                  class="primary-button theme-button text-capitalize pa-3 font-weight-bold yellow--text subtitle-1">
                              {{ $t(`button.login`) }}
                          </v-btn>
                          </v-col>
                      </v-row>
                  </div> -->
        </v-col>
        <!--        <v-col no-gutters cols="12">-->
        <!--          <v-carousel delimiter-icon="mdi-minus" hide-delimiters :show-arrows="false" cycle interval="10000"-->
        <!--                      height="auto">-->
        <!--            <v-carousel-item v-for="(banner, i) in banners" :key="i">-->
        <!--              &lt;!&ndash; <v-img :src="`${banner}`" :contain="true" :aspect-ratio="1756/792"></v-img> &ndash;&gt;-->
        <!--              <img v-if="$vuetify.breakpoint.mdAndDown" :src="`${banner}${currentLanguage}_welcome.png`" width="100%" height="100%"/>-->
        <!--              <img v-else :src="`${banner}${currentLanguage}_welcome.png`" class="px-6" width="100%" height="100%"/>-->
        <!--            </v-carousel-item>-->
        <!--          </v-carousel>-->
        <!--        </v-col>-->
      </v-row>
    </v-row>
    <v-snackbar class="pa-0" style="z-index:1000 !important;top:7%" light timeout="-1" v-model="alertShow" width="fit-content" top centered>
      <v-alert
        v-model="alertShow"
        dismissible
        :icon="alertSuccess ? 'mdi-check-circle-outline' : 'mdi-close'"
        class="mb-0 pa-1"
        :class="alertSuccess ? 'profile-alert-success' : 'profile-alert-failed'"
        light
        close-icon="mdi-close"
      >
        {{ alertMessage }}
      </v-alert>
    </v-snackbar>
  </div>
</template>

<script>
import stringFormat from 'string-format'
import { formValidator, uiHelper, locale } from '@/util'
import {
  MEMBER_CHECK_USERNAME,
  MEMBER_RESET_CHECK_USERNAME,
  MEMBER_REGISTER,
  MEMBER_SMS_REQUEST,
  MEMBER_SMS_VERIFY,
  MEMBER_GET_SMS_REQUIREMENT,
  MEMBER_RESET_SMS_VERIFICATION
} from '@/store/member.module'
import { SESSION, SHARED } from '@/constants/constants'
import { getAdClickParams } from '@/util/ad-click-helper'
import { errorCodeHelper } from '@/util/error-code-helper'

export default {
  name: 'appRegister',
  mounted() {
    this.$refs.registerForm1.reset()

    this.$refs.registerForm3.reset()
    this.checkAffiliateReferralCode()
    this.checkPhoneVerificationRequirements()
  },
  props: {
    openLoginDialog: {
      type: Function,
      required: false,
      default: () => {}
    }
  },
  created() {
    this.metaTag()
    // this.$refs.registerForm1.reset()
    // // this.$refs.registerForm2.reset()
    // this.$refs.registerForm3.reset()
  },
  data: () => ({
    mediaUrl: SHARED.MEDIA_SERVER_URL,
    showRegisterGuide: true,
    currentCurrency: uiHelper.getCurrency(),
    currentLanguage: uiHelper.getLanguage(),
    defaultLanguage: SHARED.DEFAULT_LANGUAGE,
    registerTncUrl: '',
    registerTncDialog: {
      show: false,
      title: locale.getMessage(`label.registerAccountAgreement`)
    },
    validator: formValidator,
    stringFormat: stringFormat,
    isReferralCodeReadonly: false,
    confirmNewPassword: '',
    mobileNumberPrefixList: [
      {
        text: '+91',
        value: '91',
        currency: 'INR',
        lang: 'id'
      },
      {
        text: '+880',
        value: '880',
        currency: 'BDT',
        lang: 'bd'
      }
    ],
    currencyList: ['INR', 'BDT'],
    registerObj: {
      memberCode: '',
      password: '',
      currency: SHARED.DEFAULT_CURRENCY,
      email: '',
      dialCode: SHARED.DEFAULT_CURRENCY == 'BDT' ? '880' : '91',
      mobileNumber: '',
      verificationCode: '',
      line: '',
      referralCode: '',
      isEarlyBird: '0',
      domain: '',
      language: SHARED.DEFAULT_LANGUAGE,
      platform: '',
      fp: '',
      agent_team: '',
      utm_source: uiHelper.getCookie(SESSION.UTM_SOURCE),
      utm_medium: uiHelper.getCookie(SESSION.UTM_MEDIUM),
      utm_campaign: uiHelper.getCookie(SESSION.UTM_CAMPAIGN),
      s2: uiHelper.getCookie(SESSION.UTM_S2),
      pid: uiHelper.getCookie(SESSION.PID),
      c_id: uiHelper.getCookie(SESSION.CLICKID),
      tracking_link: uiHelper.getCookie(SESSION.TRACKING_LINK),
      stag: uiHelper.getCookie(SESSION.STAG),
      fbPixelId: '',
      fbp: uiHelper.getCookie(SESSION.FB_P),
      fbc: uiHelper.getCookie(SESSION.FB_C)
    },
    confirmedPassword: '',
    step: 1,
    regSteps: 2,
    banners: ['/static/image/register/'],
    errorMsg: undefined,
    userNameErrorMsg: undefined,
    alertShow: false,
    alertSuccess: false,
    alertMessage: ''
  }),
  computed: {
    smsRequired() {
      return this.$store.state.member.smsVerificationRequired.required
    },
    smsVerificationSent() {
      return this.$store.state.member.smsVerificationSent.success
    },
    smsVerificationResult() {
      return this.$store.state.member.smsVerificationResult.success
    },
    smsVerificationError() {
      return this.$store.state.member.smsVerificationResult.message
    },
    smsRequestError() {
      return this.$store.state.member.smsVerificationSent.message
    },
    smsRequestAvailable() {
      return this.$store.state.member.smsVerificationSent.countDownTimer <= 0
    },
    smsCountdownTimer() {
      return this.$store.state.member.smsVerificationSent.countDownTimer.toString()
    },
    checkUsernameResult() {
      return this.$store.state.member.checkUsernameResult.completed
    },
    watchCurrency() {
      return this.registerObj.currency
    }
    // registerResult() {
    //   //console.log('registerResult', this.$store.state.member.registerResponse.complete)
    //   return this.$store.state.member.registerResponse.complete
    // }
  },
  watch: {
    // registerResult() {
    //   debugger;
    //   if(this.$store.state.member.registerResponse.complete){
    //     alert(this.$store.state.member.registerResponse.message);
    //     this.$store.dispatch(`${MEMBER_RESET_REGISTER_STORE}`)
    //   }
    //   console.log('this.$store.state.member.registerResponse', this.$store.state.member.registerResponse)
    // },
    watchCurrency() {
      const selected = this.mobileNumberPrefixList.find(x => x.currency == this.registerObj.currency)
      if (selected) {
        this.registerObj.dialCode = selected.value
      }
    },
    smsRequestError() {
      if (this.$store.state.member.smsVerificationSent.complete && !this.$store.state.member.smsVerificationSent.success) {
        this.errorDialog(this.$store.state.member.smsVerificationSent.code)
      }
    },
    checkUsernameResult() {
      if (this.$store.state.member.checkUsernameResult.completed) {
        if (this.$store.state.member.checkUsernameResult.success) {
          this.userNameErrorMsg = undefined
        } else {
          if (this.$store.state.member.checkUsernameResult.code == -2) {
            this.userNameErrorMsg = locale.getMessage(`fieldErrorMessage.usernameExceedLength`)
          } else if (this.$store.state.member.checkUsernameResult.code == -1) {
            this.userNameErrorMsg = locale.getMessage(`fieldErrorMessage.usernameUsed`)
          }
        }
        this.$store.dispatch(`${MEMBER_RESET_CHECK_USERNAME}`)
      }
    }
  },
  methods: {
    closeShowRegisterGuide() {
      this.showRegisterGuide = false
    },
    metaTag() {
      uiHelper.setMetaTag('url', 'https://www.ng88b.com')
      uiHelper.setTitle(`${locale.getMessage('meta.register_title')}`)
      uiHelper.setMetaTag('description', `${locale.getMessage('meta.register_description')}`)
      uiHelper.setMetaTag('keywords', `${locale.getMessage('meta.register_keyword')}`)
      // uiHelper.setCanonical('https://www.ng88b.com/en-BD/register/')
      const origin = window.location.origin
      let setLink = `${origin}/${this.currentLanguage === 'en' ? 'en-BD' : 'bn-BD'}`
      uiHelper.setCanonical(setLink)
    },
    checkUsername() {
      if (this.registerObj.memberCode.trim() !== '') {
        let registerObj = this.registerObj
        this.$store.dispatch(`${MEMBER_CHECK_USERNAME}`, {
          registerObj
        })
        this.$refs.regPassword.validate()
      }
    },
    errorDialog(errorCode) {
      let dialog = this.initializePageDialogProperty()
      dialog.title = locale.getMessage(`label.register`)
      dialog.dialogXButton = null
      dialog.message.push(errorCodeHelper.getErrorCodeDesc(errorCode))
      dialog.button.push({
        title: locale.getMessage(`label.close`),
        action: () => this.closePageDialog()
      })
      this.openPageDialog(dialog)
    },
    openPageDialog(dialog) {
      this.$eventHub.$emit('open-page-dialog', dialog)
    },
    closePageDialog() {
      this.$store.dispatch(`${MEMBER_RESET_SMS_VERIFICATION}`)
      this.$eventHub.$emit('close-page-dialog', true)
    },
    initializePageDialogProperty() {
      let initPageDialog = {
        title: locale.getMessage(`label.system`),
        dialogXButton: this.closePageDialog,
        messageTitle: '',
        message: [],
        button: []
      }
      return initPageDialog
    },
    checkPhoneVerificationRequirements() {
      this.$store.dispatch(`${MEMBER_GET_SMS_REQUIREMENT}`)
    },
    openRegisterTncDialog() {
      this.registerTncUrl = `${process.env.BASE_URL}static/html/other/${uiHelper.getLanguage()}/register-tnc.html`
      this.registerTncDialog.show = true
      this.registerTncDialog.dialogXButton = this.closePromotionTncDialog
    },
    closeRegisterTncDialog() {
      this.registerTncDialog.show = false
    },
    openLogin() {
      this.openLoginDialog()
    },

    register() {
      // if (this.smsRequired && !this.smsVerificationSent && !this.smsVerificationResult.success) {
      //   this.requestSmsVerificationCode()
      //   return
      // }
      if (this.$refs.registerForm1.validate() && this.$refs.registerForm2.validate() && this.$refs.registerForm3.validate()) {
        let jObj = this
        this.registerObj.platform = uiHelper.getPlatform()
        this.registerObj.domain = uiHelper.getHostname()
        this.registerObj.language = uiHelper.getLanguage()
        this.registerObj.fbPixelId = uiHelper.getCookie(SESSION.FB_PIXEL_CODE)
        this.registerObj.fbp = uiHelper.getCookie(SESSION.FB_P)
        this.registerObj.fbc = uiHelper.getCookie(SESSION.FB_C)
        // ad channel, landing URL and click id of the latest ad click
        Object.assign(this.registerObj, getAdClickParams())
        let existFp = typeof uiHelper.getCookie('fp_visitor') != 'undefined' && uiHelper.getCookie('fp_visitor') != null && uiHelper.getCookie('fp_visitor') != ''
        if (existFp) {
          jObj.registerObj.fp = uiHelper.getCookie('fp_visitor')
          let registerObj = this.registerObj
          this.$store.dispatch(`${MEMBER_REGISTER}`, {
            registerObj
          })
        } else {
          try {
            jObj.registerObj.fp = uiHelper.getFingerprints()
            if (jObj.registerObj.fp != '' && jObj.registerObj.fp != null) {
              uiHelper.setCookie('fp_visitor', jObj.registerObj.fp, 30)
              let registerObj = jObj.registerObj
              this.$store.dispatch(`${MEMBER_REGISTER}`, {
                registerObj
              })
            }
          } catch (err) {
            log(err)
            let registerObj = this.registerObj
            this.$store.dispatch(`${MEMBER_REGISTER}`, {
              registerObj
            })
          }
          //this.registerObj.currency = uiHelper.getCurrency()
        }
      }
    },
    formatSeconds(secs) {
      const pad = n => (n < 10 ? `0${n}` : n)

      const h = Math.floor(secs / 3600)
      const m = Math.floor(secs / 60) - h * 60
      const s = Math.floor(secs - h * 3600 - m * 60)

      return `${pad(m)}:${pad(s)}`
    },
    requestSmsVerificationCode() {
      this.$store.state.member.smsVerificationSent.success = false
      if (this.$refs.registerForm2.validate()) {
        this.registerObj.domain = uiHelper.getHostname()
        this.registerObj.language = uiHelper.getLanguage()
        let registerObj = this.registerObj
        this.$store.dispatch(`${MEMBER_SMS_REQUEST}`, {
          registerObj
        })
      }
    },
    async verifySmsCode() {
      if (this.$refs.registerForm.validate()) {
        let registerObj = this.registerObj
        this.$store.dispatch(`${MEMBER_SMS_VERIFY}`, {
          registerObj
        })
      }
    },
    checkAffiliateReferralCode() {
      let referCode = uiHelper.getCookie(SESSION.REFER_CODE)
      let afCode = uiHelper.getCookie(SESSION.AFF_CODE)
      if (afCode != null && afCode != '') {
        this.registerObj.agent_team = afCode
        this.isReferralCodeReadonly = true
      } else if (referCode != null && referCode != '') {
        this.registerObj.referralCode = referCode
        this.isReferralCodeReadonly = true
      } else {
        this.registerObj.referralCode = ''
        this.isReferralCodeReadonly = false
      }
    },
    nextPage() {
      if (this.$refs.registerForm1.validate() && !this.userNameErrorMsg) {
        this.step++
      }
    },
    previousPage() {
      this.step--
    },
    openAlert(success, msg) {
      this.alertSuccess = success
      this.alertMessage = msg
      this.alertShow = true
    }
  }
}
</script>

<style lang="scss">
.registerPopUp {
  margin: -16px -12px !important;
}
.registerBanner {
}
.registerGuideSection {
  position: relative;
  padding: 12px;
  background: #e2e2e2;
  margin: -5px -12px 10px -12px !important;
}
.linkText {
  color: #0039f6 !important;
}
.registerformfield .v-text-field > .v-input__control > .v-input__slot > .v-text-field__slot {
  font-size: 14px;
}
.specialgrey .input-field-login .v-input__control .v-input__slot {
  background-color: rgba(0, 0, 0, 0.1);
}
.registerformfield .input-field-login .v-input__control .v-input__slot {
  min-height: 30px;
  height: 30px;
}
.registerformfield .v-input__control .v-input__slot {
  min-height: 30px !important;
  height: 30px !important;
}
.register_panel-af {
  padding: 0 12px 16px 12px;
  justify-content: center;
  .register-wrapper-af {
    max-width: 1240px;
    margin: auto;
    //border: 8px solid var(--v-primary-base);
    display: flex;
    justify-content: space-between;
    gap: 1em;

    .sign-up-title {
      justify-content: center;
      color: var(--v-secondary-base);
      border-bottom: 1px solid var(--v-secondary-base);
      padding-bottom: 0.5em;
      margin-bottom: 1.5em;
    }

    .circle-button {
      padding: 12px;
      border-radius: 4px;
      height: 45px;
      background-color: var(--v-primary-lighten1);
    }

    .circle-button:hover {
      background-color: var(--v-primary-base);
    }

    .otp-button {
      background-color: var(--v-primary-base);
      border-radius: 4px;
    }

    .v-select__selection {
      color: #000000;
    }

    .input-field .v-icon,
    .input-field .v-input__icon {
      color: var(--v-primary-base);
    }

    .v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-inner {
      margin-top: 0px;
    }
  }
}

@media (max-width: 599px) {
  .register_panel-af {
    background-color: #ffffff;

    .register-wrapper-af {
      border: unset;
    }
  }
}

@media (max-width: 440px) {
  //.registerformfield .v-input__control .v-input__slot{
  //  padding: 0 5px !important;
  //}
  //.v-avatar.language-button {
  //  width: 15px !important;
  //  height: 15px !important;
  //}
  .input-field .v-input__slot .v-select__slot .v-select__selections .v-select__selection--comma {
    font-size: 12.5px;
  }
}
</style>
